import React from "react";
import { withTheme } from "styled-components";

import { Rotate, InlineRotate } from "./styles";

class Icon extends React.Component {
  render() {
    if (!this.props.theme.img) return;
    if (this.props.type === "inline")
      return (
        <InlineRotate>
          <div>
            <img src={this.props.theme.img} />
          </div>
        </InlineRotate>
      );
    return <Rotate src={this.props.theme.img} />;
  }
}

export default withTheme(Icon);



// WEBPACK FOOTER //
// ./src/components/Home/Icon.jsx